import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=28df69bd&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"
import style0 from "./recruit.vue?vue&type=style&index=0&id=28df69bd&prod&lang=scss&scoped=true"
import style1 from "./recruit.vue?vue&type=style&index=1&id=28df69bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df69bd",
  null
  
)

export default component.exports